// extracted by mini-css-extract-plugin
export default {"box":"Search_box__lZq0U","icon":"Search_icon__dytsk"};